export const formatPhoneNumber = (value, countryCode) => {
    // Remove all non-digits
    let digits = value.replace(/\D/g, '');
    
    // Determine max length based on country code
    let maxLength;
    if (
        ['+1', '+1-684', '+1-264', '+1-268', '+1-242', '+1-441', '+1-473', '+1-767', '+1-809', '+1-869', '+1-758', '+1-784', '+1-868', '+1-876'].includes(countryCode)
    ) {
        maxLength = 10; // US/Canada and Caribbean
    } else if (['+44', '+91', '+92', '+880', '+86'].includes(countryCode)) {
        maxLength = 10; // UK, India, Pakistan, Bangladesh, China
    } else {
        maxLength = 12; // Default for other countries
    }

    digits = digits.slice(0, maxLength);

    let formatted = '';

    if (
        ['+1', '+1-684', '+1-264', '+1-268', '+1-242', '+1-441', '+1-473', '+1-767', '+1-809', '+1-869', '+1-758', '+1-784', '+1-868', '+1-876'].includes(countryCode)
    ) {
        if (digits.length > 6) {
            formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
        } else if (digits.length > 3) {
            formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
        } else {
            formatted = digits;
        }
    } else if (countryCode === '+44' || countryCode === '+86') {
        if (digits.length > 4) {
            formatted = `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
        } else {
            formatted = digits;
        }
    } else if (countryCode === '+91') {
        if (digits.length > 4) {
            formatted = `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
        } else {
            formatted = digits;
        }
    } else if (countryCode === '+92') {
        if (digits.length > 6) {
            formatted = `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
        } else if (digits.length > 3) {
            formatted = `${digits.slice(0, 3)} ${digits.slice(3)}`;
        } else {
            formatted = digits;
        }
    } else {
        if (digits.length > 6) {
            formatted = `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
        } else if (digits.length > 3) {
            formatted = `${digits.slice(0, 3)} ${digits.slice(3)}`;
        } else {
            formatted = digits;
        }
    }

    return formatted;
};